require('cookieconsent');

function initCookieConsent() {

  window.cookie_policy_url = (typeof variable === 'undefined') ? '/cookies-notice' : window.cookie_policy_url;

  window.cookieconsent.initialise({
    'palette': {
      'popup': {
        'background': '#012330',
        'text': '#ffffff',
      },
      'button': {
        'background': '#ffffff',
        'text': '#012330',
      },
    },
    'content': {
      'message': 'ESA uses cookies to track visits to our website only, no personal information is collected.<br>By continuing to use the site you are agreeing to our use of cookies.',
      'dismiss': 'I agree',
      'link': 'Find out more about our cookies',
      'href': window.cookie_policy_url,
    },
  });
};

jQuery(function(){
  initCookieConsent();
})

// jQuery(document).ready(function () {
//   initCookieConsent();
// });
